import React, { useEffect, useState } from 'react'

import './QuizStyles.scss'
import { Modal } from 'antd'
import EQuiz from './EQuiz'
import { useTranslation } from 'react-i18next'

const viewTypes = {
  general: 'general',
  simulation: 'simulation',
  ai: 'ai'
}
const QuizHandler = props => {
  const {
    handleCloseQuizModal,
    pageBuilder,
    pageBuilder: { contentId }
  } = props

  const [viewType, setViewType] = useState(null)

  useEffect(() => {
    if (contentId) {
      setViewType(viewTypes.general)
    }
  }, [])

  const goToGeneralQuiz = () => {
    setViewType(viewTypes.general)
  }

  const goToSimulationQuiz = () => {
    setViewType(viewTypes.simulation)
  }
  const { t } = useTranslation()

  return (
    <>
      {!viewType && (
        <Modal
          title={t('v4:create_quiz')}
          visible
          onCancel={handleCloseQuizModal}
          footer={null}
          centered
        >
          <div className="quiz-choice-container">
            <div className="quiz-choice" onClick={goToGeneralQuiz}>
              {t('v4:general_quiz')}
            </div>
            <div className="quiz-choice" onClick={goToSimulationQuiz}>
              {t('v4:simulation_quiz')}
            </div>
          </div>
        </Modal>
      )}

      {viewType === viewTypes.general && <EQuiz {...props} />}

      {viewType === viewTypes.simulation && (
        <EQuiz
          {...props}
          pageBuilder={{ ...pageBuilder, isSimulation: true }}
        />
      )}
    </>
  )
}

export default QuizHandler
